//#region Libraries
import { useEffect } from "react";
//#endregion
//#region Styles
import {
	Row,
	Column,
	SubtitleSection,
	TitleSection,
	ParagraphSection,
	Fields,
	Part,
} from "components/styles";
//#endregion
//#region Components
import HandlerRadio from "components/CustomRadio/CustomRadio";
import NotificationNoContent from "components/NotificationNoContent/NotificationNoContent";
import TeacherField from "./components/TeacherField/TeacherField";
//#endregion
//#region Utils
import usePrevious from "utils/hooks/usePrevious";
import useEventFormContext from "views/Eventos/components/FormCreateEvent/ManualLoadingForm/utils/context/useEventFormContext";
import CustomSelect from "components/CustomSelect/CustomSelect";
import { ORGANIZER_IDS } from "config/constants";
import LocationPlaceStep1 from "views/components/LocationPartForm/components/PlaceControls/components/LocationPlaceStep1/LocationPlaceStep1";
//#endregion

const Part1 = ({
	form,
	changeField,
	errors,
	errorTexts,
	fillTeacherZoomAccountDetail,
	allCampus,
}) => {
	const { organizerId, teacher, payGradeId } = form;
	//#region Custom Hooks
	const { data, isWorkshopEventType } = useEventFormContext();
	const { organizers, teacherAccounts, payGrades } = data;
	const prevOrganizerId = usePrevious(organizerId);
	//#endregion
	//#region Effects
	useEffect(() => {
		if (
			organizerId !== 1 ||
			typeof prevOrganizerId === "undefined" ||
			prevOrganizerId === organizerId
		)
			return;
		if (!form.teacher.search.id) return;
		// const { fullName, accountId } = form.teacher.free;
		changeTeacherField("free", form.teacher.free, {
			fullName: false,
			accountId: false,
		});
	}, [organizerId]);
	//#endregion
	//#region Functions
	const changeOrganizerField = value => {
		changeField("organizerId", value, false);
	};
	const changeTeacherField = (field, newTeacher, errorsValue) => {
		const { teacher } = form;
		changeField(
			"teacher",
			{
				...teacher,
				[field]: newTeacher,
			},
			{
				...errors.teacher,
				[field]: errorsValue,
			}
		);
	};
	const changePayGradeField = value => {
		changeField("payGradeId", value, false);
	};
	//Campus Organizador
	const changePlaceCampus = ({ id, text }) => {
		changeField("placeOrganization", {
			"campus": { id, name: text },
		}, {
			...errors.placeOrganization,
			"campus": false,
		});
	}
	//#endregion
	return (
		<>
			<Part>
				<TitleSection>Organizado por:</TitleSection>
				<Fields className="fields">
					<Row
						className="flex-start"
						gap="40px"
					>
						<HandlerRadio
							value={organizerId}
							onChange={changeOrganizerField}
							radiosProps={organizers.map(item => ({
								value: item.id,
								label: item.name,
							}))}
							error={errors.organizerId}
							errorText="Es necesario seleccionar un área organizadora del evento"
						/>
					</Row>
					{organizerId === 0 ? (
						<NotificationNoContent
							title="Aún no has señalado una área organizadora"
							description="Selecciona una para mostrarte las opciones de docente/ponente a cargo"
						/>
					) : (
						<Column gap="30px">
							<Column gap="10px">
								<SubtitleSection>
									Docente a cargo
								</SubtitleSection>
								<ParagraphSection>
									Docente solo aplica para vida universitaria
								</ParagraphSection>
							</Column>
							<TeacherField
								teacher={teacher}
								changeField={changeTeacherField}
								errors={errors.teacher}
								errorTexts={errorTexts}
								showSearchTeacher={
									(organizerId === ORGANIZER_IDS.UNIVERSITY_LIFE || organizerId === ORGANIZER_IDS.COMPLEMENT_SERVICES)? true : false
								}
								teacherAccounts={teacherAccounts}
								fillTeacherZoomAccountDetail={
									fillTeacherZoomAccountDetail
								}
							/>
						</Column>
					)}
					{isWorkshopEventType && (
						<CustomSelect
							label="Categoría salarial"
							value={payGradeId}
							width={{
								container: "max-width",
								containerSelect: "220px",
							}}
							onChange={changePayGradeField}
							defaultOptionText="Selecciona una categoría"
							optionsProps={payGrades.map(({ id }) => ({
								value: id,
								text: id,
							}))}
							error={errors.payGradeId}
							errorText="Es necesario seleccionar una categoría salarial"
						/>
					)}
					<LocationPlaceStep1
						campusWidth="340px"
						campus={form.placeOrganization.campus}
						error={errors.placeOrganization.campus}
						allCampus={allCampus}
						changeCampus={changePlaceCampus}
						as="Campus Organizador"
						title="Campus Organizador (opcional):"
						viewHelper={false} />
				</Fields>
			</Part>
		</>
	);
};

export default Part1;
